export interface ImageVersion {
  original: ImageData;
  thumb: ImageData;
  small: ImageData;
  medium: ImageData;
  large: ImageData;
  xlarge: ImageData;
}

export interface ImageData {
  url: string;
  width: number;
  height: number;
}

export interface Amenity {
  id: string;
  name: string;
  iconURL: string;
}

export interface BaseLocation {
  id: string;
  name: string;
  streetAddress: string;
  city: string;
  timezone: string;
}

interface LocationInfo extends BaseLocation {
  wlHomeLink: string | null;
  country: string | null;
  state: string;
  stateName: string;
  postalCode: string | null;
  direction: string | null;
  longitude: number | null;
  latitude: number | null;
}

export interface Location extends LocationInfo {
  logo: ImageData | null;
  maxCapacity: number;
  currencyCode: string | null;
  pricingInclusion: string | null;
  images: ImageVersion[];
  amenities: Amenity[];
  smartPricingEnabled: boolean;
}

function toImageData(data: any): ImageData {
  return {
    url: data.url,
    width: data.width,
    height: data.height,
  };
}

export function toImage(data: any): ImageVersion {
  return {
    original: toImageData(data.original),
    thumb: toImageData(data.thumb),
    small: toImageData(data.small),
    medium: toImageData(data.medium),
    large: toImageData(data.large),
    xlarge: toImageData(data.xlarge),
  };
}

export function toLocation(data: any): Location {
  return {
    id: data.id,
    maxCapacity: data.max_capacity,
    name: data.name,
    logo: data.logo ? toImageData(data.logo) : null,
    streetAddress: data.street_address,
    city: data.city,
    timezone: data.time_zone,
    state: data.state,
    stateName: data.state_name,
    wlHomeLink: data.wl_home_link,
    postalCode: data.postal_code,
    currencyCode: data.currency || null,
    country: data.country,
    images: data.images.map(toImage),
    direction: data.direction,
    longitude: Number(data.longitude),
    latitude: Number(data.latitude),
    pricingInclusion: data.pricing_inclusion,
    amenities: data.amenities.map(
      (amenity: any): Amenity => ({
        id: amenity.icon_code,
        name: amenity.description,
        iconURL: amenity.icon_url,
      })
    ),
    smartPricingEnabled: data.smart_pricing_enabled,
  };
}

export interface SimpleLocation {
  id: string;
  name: string;
  shortAddress: string;
}

export const toSimpleLocation = (data: any): SimpleLocation => {
  return {
    id: data.id,
    name: data.name,
    shortAddress: data.short_address,
  };
};
